import React from 'react';
import { PropTypes } from 'prop-types';
import { InputAdornment } from '@mui/material';
import { colors, SVGIcon, Spinner, FormElements } from '@custom-components';
import SelectedChipBar from './SelectedChipBar';
import { CustomInputAdornment } from '../MultiSearchSelect.styles';

function MultiSearchSelectInput(props) {
  const {
    name,
    label,
    variant,
    inputProps,
    isOpen,
    loading,
    readOnly,
    shrinkLabel,
    styledProps,
    remove,
    selectedOptions,
    onInputChange,
    displayCount,
    required,
    onBlur,
    error,
    errorText,
    disabledInputChange
  } = props;

  return (
    <FormElements.TextInput
      name={name}
      label={label}
      variant={variant}
      onChange={onInputChange}
      styledProps={styledProps}
      required={required}
      onBlur={onBlur}
      error={error}
      errorText={errorText}
      InputProps={{
        ...inputProps,
        startAdornment: (
          <CustomInputAdornment position="start">
            <SelectedChipBar
              remove={remove}
              selectedOptions={selectedOptions}
              displayCount={displayCount}
              disabled={readOnly}
            />
          </CustomInputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {loading ? (
              <Spinner data-testid="multi-search-select-loading" size={20} />
            ) : (
              <SVGIcon
                data-testid="multi-search-select-expand"
                selectedIcon="arrowFill"
                iconColor={colors.colorGrey03}
                rotate={isOpen ? 180 : 0}
              />
            )}
          </InputAdornment>
        )
      }}
      InputLabelProps={{ shrink: shrinkLabel }}
      disabled={loading || readOnly || disabledInputChange}
    />
  );
}

MultiSearchSelectInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['standard', 'outlined']),
  readOnly: PropTypes.bool,
  styledProps: PropTypes.shape({}),
  isOpen: PropTypes.bool.isRequired,
  shrinkLabel: PropTypes.bool.isRequired,
  inputProps: PropTypes.shape({}),
  remove: PropTypes.func.isRequired,
  selectedOptions: PropTypes.shape([]),
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  displayCount: PropTypes.number,
  disabledInputChange: PropTypes.bool
};

MultiSearchSelectInput.defaultProps = {
  name: '',
  label: '',
  loading: false,
  variant: 'standard',
  readOnly: false,
  selectedOptions: [],
  styledProps: {},
  inputProps: {},
  onInputChange: () => {},
  onBlur: () => {},
  required: false,
  error: false,
  errorText: '',
  displayCount: 0,
  disabledInputChange: false
};

export default MultiSearchSelectInput;
